// Modernizr.on('webp', function (result) {
//   if (result) {
//     // supported
//   } else {
//     // not-supported
//   }
// });

// IE polyfill
// objectFitVideos();

// rolling start!
$(function(){
  if ('ontouchstart' in window || 'ontouch' in window) {
    $('body').addClass('touch');
  };
  
  $('.language-select').on('change', function() {
    var selectedOption = $(this).find('option:selected').attr("value");
    console.log(selectedOption);

    $('input[name="list"]').val(selectedOption);
  });

  // hilight side nav on click
  $('.side-nav__list a').click( function() {
    $('.side-nav__list a').parent().removeClass('selected');
    $(this).parent().addClass('selected');
  });

  // hamburger action
  $('.hamburger').click(function(){
    $(this).toggleClass('is-active');
    $('body').toggleClass('menu-active');
  });

  // show hide email terms
  $('.button-terms').click(function(){
    $('.terms').toggleClass('visible');
  });

  // Create the dropdown base
  $('<select class="uniform" />').appendTo('.side-navigation');

  // Create default option 'Go to...'
  $('<option />', {
     'selected': 'selected',
     'value'   : '',
     'text'    : '-- select --'
  }).appendTo('.side-navigation select');

  // Populate dropdown with menu items
  $('.side-navigation a').each(function() {
   var el = $(this);
   $('<option />', {
       'value'   : el.attr('href'),
       'text'    : el.text()
   }).appendTo('.side-navigation select');
  });

  $('.side-navigation select').change(function() {
    $('.side-navigation select option:selected').val();
    // window.location.hash = $(this).val();
    document.querySelector($(this).val()).scrollIntoView({ 
      behavior: 'smooth' 
    });
  });

  // uniform the select bars only
  $('.uniform').uniform();

  // accordion
  if (document.querySelector('.faq-content-area:not(no-expanding) .faq-item')) {
    $('.faq-content-area:not(no-expanding) .faq-item').accordion({
      "transitionSpeed": 400
    });
  }

  // toggle aria modal for games buying
  if (document.querySelector('.modal')) {
    $('#buying-options, .modal-close').click(function(){
      $('body').toggleClass('modal-open');
      $('.modal').attr('aria-expanded', function (i, attr) {
        return attr == 'true' ? 'false' : 'true'
      });

      $('.modal').click(function() {
        $('body').removeClass('modal-open');
        $('.modal').attr('aria-expanded', 'false');
      });

      $(document).on('keydown',function(event) {
        if (event.keyCode == 27) {
          $('body').removeClass('modal-open');
          $('.modal').attr('aria-expanded', 'false');
        }
      });
    });
  }

});